import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { HiArrowsUpDown, HiCheck } from "react-icons/hi2";

export interface SortOption {
  value: string;
  label: string;
}

interface props {
  options: SortOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const SortDropdown: React.FC<props> = ({ options, value, onChange, disabled }) => {
  const [open, setOpen] = useState<boolean>(false);
  const selected = options.find((option) => option.value === value);

  return (
    <Dropdown isOpen={open} toggle={() => setOpen(!open)} className="gm-sort-dropdown">
      <DropdownToggle
        className="gm-outline-button"
        disabled={disabled}
        title={selected ? `Ordenado por: ${selected.label}` : "Ordenar"}
      >
        <HiArrowsUpDown size={18} />
        <span>Ordenar</span>
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem header>Ordenar por</DropdownItem>
        {options.map((option) => (
          <DropdownItem
            key={option.value}
            active={option.value === value}
            onClick={() => onChange(option.value)}
          >
            <span>{option.label}</span>
            {option.value === value && <HiCheck size={16} />}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default SortDropdown;
